import { IconProps } from "./types";

export const IconTrash = ({ size = 24 }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size}>
      <path
        stroke={"currentColor"}
        strokeLinejoin="round"
        strokeWidth={2}
        fill={"none"}
        d="m4 6 1.143 16h13.714L20 6"
      />
      <path stroke={"currentColor"} strokeWidth={2} d="M9.5 9v10M14.5 9v10" />
      <path
        stroke={"currentColor"}
        strokeLinejoin="round"
        strokeWidth={2}
        d="m17 6-1-4H8L7 6"
        fill={"none"}
      />
      <path stroke={"currentColor"} strokeWidth={2} d="M0 6h24" />
    </svg>
  );
};
